import React from 'react';
import { SectionLabel } from './SectionLabel';
export function ChihuahuaNote() {
  return <section className="w-full border-t border-line bg-sand" aria-labelledby="chihuahua-heading" data-id="element-67" data-mp="2bg82j2jvlj88">
      <div className="mx-auto max-w-readable px-4 py-14 text-center sm:px-5 sm:py-20" data-id="element-68" data-mp="2q4vyh9xmvuyp">
        <SectionLabel align="center" data-id="element-69" data-mp="2l4ztb7d79xhk">One last thing</SectionLabel>

        <h2 id="chihuahua-heading" className="mt-5 font-display text-[1.75rem] font-semibold leading-tight text-ink sm:mt-6 sm:text-[2.5rem]" data-id="element-70" data-mp="2l7vquul4yk5h">
          This book works for every dog.
        </h2>

        <p className="mt-5 text-[15px] leading-relaxed text-ink/75 sm:text-lg" data-id="element-71" data-mp="26h4y9kbpzh1b">
          Except chihuahuas. Those ones are terrible — that’s a real
          challenge. 😂😂😂
        </p>

        <p className="mt-4 text-[15px] leading-relaxed text-ink/75 sm:text-lg" data-id="element-72" data-mp="3hviimf79lecl">
          If you manage to tame one in less than 30 days, the book is on me. 😂😂
        </p>

        <p className="mt-9 border-t border-line pt-8 font-display text-xl font-semibold leading-snug text-ink sm:mt-10 sm:text-2xl" data-id="element-73" data-mp="3dwjeuxx9rnmq">
          This book works to tame every dog.
        </p>
      </div>
    </section>;
}